import { KeyTextPair, KeyTextPairUtils } from '@models/key-text-pair.model';

export class RamRolesOptions {
  static AuditorTest: KeyTextPair = {
    key: '658',
    text: 'TST_LTL_OBI_AUDITOR',
  };
  static Auditor: KeyTextPair = {
    key: '659',
    text: 'LTL_OBI_AUDITOR',
  };
  static BuilderTest: KeyTextPair = {
    key: '660',
    text: 'TST_LTL_OBI_BUILDER',
  };
  static Builder: KeyTextPair = {
    key: '661',
    text: 'LTL_OBI_BUILDER',
  };
  static ViewerTest: KeyTextPair = {
    key: '662',
    text: 'TST_LTL_OBI_VIEWER',
  };
  static Viewer: KeyTextPair = {
    key: '663',
    text: 'LTL_OBI_VIEWER',
  };
  // static ApproverTest: KeyTextPair = {
  //   key: '664',
  //   text: 'TST_LTL_OBI_APPROVER',
  // };
  // static Approver: KeyTextPair = {
  //   key: '665',
  //   text: 'LTL_OBI_APPROVER',
  // };
  static ITSupportTest: KeyTextPair = {
    key: '666',
    text: 'TST_LTL_OBI_IT',
  };
  static ITSupport: KeyTextPair = {
    key: '667',
    text: 'LTL_OBI_IT',
  };

  static getAllTextValues(): string[] {
    return KeyTextPairUtils.getAllTextValues(Object.values(RamRolesOptions));
  }
}
